import React,{useState,useEffect} from 'react'
import { Bar } from 'react-chartjs-2';
import { useSelector } from "react-redux";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { useGetBarChartDataQuery } from '../slices/getqueries/getqueriesApi';
  ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);
function NewBarChartComponent({serviceGroupData}) {
  const { userInfo } = useSelector((state) => state.auth);
  const {clientId} = userInfo;
  const [activeTab, setActiveTab] = useState(null);
  const [period, setPeriod] = useState('this_year');
  const groupId = serviceGroupData?.[activeTab]?.groupId;
  const { data, isLoading, isError } = useGetBarChartDataQuery(
    {
      clientname: clientId,
      groupId,
      period,
    },
    {
      skip: !groupId, 
    }
  );
  useEffect(() => {
    if (
      serviceGroupData &&
      typeof serviceGroupData === "object" &&
      Object.keys(serviceGroupData).length > 0 &&
      (activeTab === null || !serviceGroupData[activeTab])
    ) {
      const firstKey = Object.keys(serviceGroupData)[0];
      if (firstKey) {
        setActiveTab(firstKey); 
      }
    }
  }, [serviceGroupData,activeTab]);
  

  const labels = data?.data?.labels || [];
  const values = data?.data?.values || [];

 
  const getDynamicStepSize = (maxValue) => {
    if (maxValue <= 0) return 1;
  
    
    let numberOfSteps;
    if (maxValue <= 10) numberOfSteps = 5;
    else if (maxValue <= 100 && maxValue>10) numberOfSteps = 6;
    else if (maxValue <= 1000 && maxValue>100) numberOfSteps = 7;
    else if (maxValue <= 10000 && maxValue>1000) numberOfSteps = 8;
   
  
    const rawStep = maxValue / numberOfSteps;
  
    
    const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
    const residual = rawStep / magnitude;
  
    let niceStep;
    if (residual <= 1) niceStep = 1;
    else if (residual <= 2) niceStep = 2;
    else if (residual <= 5) niceStep = 5;
    else niceStep = 10;
  
    return niceStep * magnitude;
  };
  
  
  

  const maxValue = Math.max(...values, 0); 
  const stepSize = getDynamicStepSize(maxValue);


  const chartdata = {
    labels,
    datasets: [
      {
        label: 'Credit Used',
        data: values,
        backgroundColor: '#295BAC',
        borderRadius: 5,
        barThickness: 18,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `₹${context.parsed.y.toLocaleString()}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          stepSize: stepSize,
          callback: (value) =>
            value >= 100000 ? `₹${value / 100000}L` :
            value >= 1000 ? `₹${value}` : `₹${value}`,
          padding: 10,
        },    
        grid: {
          drawBorder: false,
          drawTicks:false,  
          color: '#BDBDBD',
        },
        border:{
          dash:[5,5],
          display: false
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
          borderDash:[5,5],
          color: "#e0e0e0"
        },
        border:{
          dash:[5,5],
          display: false
        },
      },
    },
  };
  const categories = Object.keys(serviceGroupData || {});
  return (
    <>
    <div className="flex flex-col md:flex-row gap-4 md:gap-12 justify-between items-start mb-4">
      <div className="flex items-center gap-2">
        <div>
        <h2 className="font-[600] text-[14px] whitespace-nowrap">Credit Used</h2>
        </div>
        <select className="border rounded-[10px] px-2 py-1 text-sm text-[#6B7280]" onChange={(e) => setPeriod(e.target.value.replace(/\s+/g, '_'))}
            value={period}>
            <option value="today">Today</option>
            <option value="this_week">This Week</option>
            <option value="last_week">Last Week</option>
            <option value="this_month">This Month</option>
            <option value="last_month">Last Month</option>
            <option value="last_6_months">Last 6 Months</option>
            <option value="this_year">This Year</option>
            <option value="last_year">Last Year</option>
        </select>
        </div>
      <div className="flex flex-wrap gap-[4px] justify-start">
      {categories.map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-5 py-2 rounded-full text-md font-medium ${
            activeTab === tab
              ? 'bg-[#204887] text-white'
              : 'bg-[#E5EFFF] text-[#204887]'
          }`}
        >
          {tab}
        </button>
      ))}
      </div>
    </div>


    <div className="h-[250px] w-full overflow-x-auto md:overflow-x-hidden">
        <div className="w-[800px] md:w-full h-[250px]">
          {isLoading ? (
            
            <div className="w-[800px] md:w-full h-[250px] animate-pulse bg-[#f3f4f6] rounded-lg flex items-end gap-2 p-4">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="w-[5%] bg-gray-300 rounded-md"
                style={{
                  height: `${Math.floor(Math.random() * 120 + 40)}px`, 
                }}
              />
            ))}
          </div>
          ) : values.every((v) => v === 0) ? (
            <div className="flex justify-center items-center h-[250px] text-gray-400 text-xl font-semibold border border-dashed border-gray-300 rounded-lg">
             No Data Found
            </div>
          ): (
            <Bar data={chartdata} options={options} />
          )}
        </div>
      </div>
</>
  )
}

export default NewBarChartComponent
